import { DealConfirmation } from "shared/cubiq-model-multi-asset";
import { CustomValue } from "shared/cubiq-model-multi-asset";
import { TradeRate } from "./TradeRate";

export class TradeDeal {
  // IDs
  public dealId: string; // DealImpl: id; used to be number before 10/08/2017
  public dealRef: string;
  public orderId: string; // DealImpl: orderId;
  public orderRef: string;
  public clOrderId: string; // DealImpl: clOrdId;
  // product
  public baseCcy: string;
  public nonBaseCcy: string;
  public isInvert: boolean;
  public instrument: string; // DealImpl: productId / note: ccy pair
  public productType: string; // DealImpl: productType; / note: spot/fwd/fwd off/ndf etc
  public orderTypeId: string; // DealImpl: orderType; / ENUM( TP, SL_BID, CALL, BMARK, SL_ASK, SL_ATRATE, TSL, TSL_BID, TSL_ASK, ALGO)
  public orderTypeName: string;
  public strategyId: number; // DealImpl: strategyId;
  public strategyName: string; // note: empty for now
  public dealDir: boolean; // DealImpl: isBuy; / true = buy; false = sell;
  public dealDirStr: string; // DealImpl: isBuy; / true = Buy; false = Sell;
  public dealStateId: number; // DealImpl: dealStateId; / ENUM(ACTIVE, FILL_ERROR, COMPLETED, CANCELLED, ACK_TIME_OUT, NAK, DONE_NO_STP, STP_HOLD)
  public dealStateName: string; // Not in DealImpl
  public dealtCcy: string;
  public assetClass: string; // 'FX'
  public fixingCode: string; // DealImpl: fixingCode;
  public bmarkFixingDateTime: string; // for benchmarks fixing date
  public valueDateTenor: string;
  public bmarkValueDateTenor: string;
  // users
  public entryUserId: string; // DealImpl: entryUserId;
  public entryUserName: string; // Not in DealImpl / note: resolve with userLookup
  public fillUserId: number;
  public fillUserName: string; // DealImpl: fillUserName;
  public fillUserCode: string; // DealImpl: fillUserCode;
  public confirmUserId: number; // DealImpl: confirmedSalesUserId;
  public confirmUserName: string; // Not in DealImpl / note: resolve with userLookup

  // groups
  public traderGroupId: number; // DealImpl: traderGroupId;
  public traderGroupName: string; // Not in DealImpl / note: resolve traderGroupLookup
  public salesGroupId: number; // DealImpl: salesGroupId;
  public salesGroupName: string; // Not in DealImpl
  // client/account
  public clientId: string; // DealImpl: clientCode;
  public clientName: string; // Not in DealImpl / note: resolve with clientLookup
  public clientBranchCode: string; // DealImpl: clientBranchCode;
  public accountId: string; // DealImpl: accountCode;
  public accountName: string; // Not in DealImpl / note: resolve with accountLookup
  public accountBookingType: string; // Not in DealImpl / note: resolve with accountLookup
  public accountBookingCd: string; // Not in DealImpl
  public accountContact: string; // Not in DealImpl
  // rates
  public orderRate: number; // DealImpl: requestedPx;
  public marketSpot: number; // DealImpl: spotMarketRate;
  public marketPts: number; // DealImpl: forwardMarketPoints;
  public marketAllIn: number; // DealImpl: forwardMarketRate;
  public clientSpot: number; // DealImpl: spotClientRate;
  public clientPts: number; // DealImpl: forwardPoints;
  public clientAllIn: number; // DealImpl: allInClientRate;
  // rates (formatted)
  public orderRateStr: string; // DealImpl: requestedPx;
  public marketSpotStr: string; // DealImpl: spotMarketRate;
  public marketPtsStr: string; // DealImpl: forwardMarketPoints;
  public marketAllInStr: string; // DealImpl: forwardMarketRate;
  public clientSpotStr: string; // DealImpl: spotClientRate;
  public clientPtsStr: string; // DealImpl: forwardPoints;
  public clientAllInStr: string; // DealImpl: allInClientRate;
  // amounts
  public dealtAmt: number; // DealImpl: amt1;
  public dealtAmtUsd: number; // DealImpl: usdEquivAmt;
  public counterAmt: number; // DealImpl: amt2

  public dealtAmtStr: string; // DealImpl: amt1;
  public dealtAmtUsdStr: string; // DealImpl: usdEquivAmt;
  public counterAmtStr: string; // DealImpl: amt2

  // dates
  public tradeDate: number; // DealImpl: tradeDate;
  public valueDate: number; // DealImpl: valueDate; /timestamp in milliseconds
  public fixingDate: number; // DealImpl: fixingDate; /timestamp in milliseconds
  public creationDate: number; // DealImpl: ; / timestamp in milliseconds
  public entryDate: number; // DealImpl: entryDate; / timestamp in milliseconds
  // comments
  public fillComment: string; // DealImpl: fillComment;
  public clientComment: string; // DealImpl: clientComment;
  public privateComment: string; // DealImpl: privateComment;

  public holdStp: boolean;

  public dealConfirmations: Array<DealConfirmation>;

  public marketRateAtFill: string;

  public manualDealRef: string;

  public triggerTime: number;

  public triggerRate: string;

  public tradeRates: Array<TradeRate>;

  public oboAccount: string;

  public oboClient: string;

  public lastMkt: string;

  public customValues: Array<CustomValue>;
}
